/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { i18nNamespaces as namespace } from "srs.sharedcomponents/lib/esm/i18n/i18n";
import { IDropDownOption } from "srs.sharedcomponents/lib/esm/models/srs.formDropdownOption.model";
import {
  useAppDispatch,
  useAppSelector,
} from "srs.sharedcomponents/lib/esm/redux/hooks";

import {
  IFacetedItem,
  IFacetedSearchRequest,
} from "srs.sharedcomponents/lib/esm/models/facetedSearch/facetedSearch.model";
import {
  getFacetedOptions,
  getFacetedConfigurations,
} from "srs.sharedcomponents/lib/esm/redux/slices/facetedSearchSlice";
import {
  getFacetedProducts,
  updateRequest,
  clearState as clearProducts,
  updateFromMainZone,
  clearProductRefineCatalogs,
  clearState,
  getSortOption,
} from "srs.sharedcomponents/lib/esm/redux/slices/facetedProductListSlice";
import * as S from "./styles";
import { FacetedSearchType } from "srs.sharedcomponents/lib/esm/utils/enums";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslate } from "srs.sharedcomponents/lib/esm/hooks/useTranslate";
import { useTranslation } from "react-i18next";
import {
  clearAll,
  clearRefineCatalogs,
  items,
} from "srs.sharedcomponents/lib/esm/redux/slices/productlistSlice";
import LoadingIndicator from "srs.sharedcomponents/lib/esm/components/LoadingIndicator";
import FacetedSearchSelectInput from "srs.sharedcomponents/lib/esm/components/molecules/FacetedSearchSelectInput/FacetedSearchSelectInput";
import { IItemShortResponse } from "srs.sharedcomponents/lib/esm/models/responses/srs.itemShortResponse.model";
interface IFormSchema {
  [key: string]: string;
}
interface IFacetedSearchProps {
  mainZone?: boolean;
  isKeyFinder?: boolean;
  handleReset?: () => void;
  handleShowFacetResult: (isShow: boolean) => void;
  resetInput?: boolean;
  setResetInputFields: any;
  refineYourSearchInput?: any[] | null;
  showFacetResult?: boolean;
  setRefineYourSearchInput: React.Dispatch<React.SetStateAction<any>>;
  setShowRefineSearch: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchText: React.Dispatch<React.SetStateAction<any>>;
  onSearchButtonClick: (value: boolean) => void;
  disableSearchButton: boolean;
  vinSearchValue: string;
  keyPartNumberSearchValue: string;
  disabled?: boolean;
  onToggleVinInput?: (disabled: boolean) => void;
  onToggleKeyPartInput?: (disabled: boolean) => void;
}
interface LevelInfo {
  level: number;
  name: string;
}
interface FacetConfiguration {
  levelInfos: LevelInfo[];
  rootTag: string;
}

const FacetedSearch: React.FC<IFacetedSearchProps> = ({
  mainZone,
  isKeyFinder,
  handleReset,
  handleShowFacetResult,
  resetInput,
  setResetInputFields,
  showFacetResult,
  refineYourSearchInput,
  setRefineYourSearchInput,
  setShowRefineSearch,
  setSearchText,
  onSearchButtonClick,
  disableSearchButton,
  vinSearchValue,
  keyPartNumberSearchValue,
  onToggleVinInput,
  onToggleKeyPartInput,
}) => {
  const disableSelects =
    keyPartNumberSearchValue.length > 0 || vinSearchValue.length > 0;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [enableSearchButton, setEnableSearchButton] = useState<boolean>(false);
  const { facetItems, facetConfiguration } = useAppSelector(
    (state) => state.facetedSearch
  );
  const [resetInputValues, setResetInputValues] = useState<boolean>(false);
  const { fromMainZone, request: requestFromMainZone } = useAppSelector(
    (state) => state.facetedProductList
  );
  const sortOption = useAppSelector(getSortOption);
  const prevRefineSearchInput = useRef(refineYourSearchInput);
  const [formInputs, setFormInputs] = useState<any>(undefined);
  const { translate } = useTranslate();
  const { search } = useLocation();
  const location = useLocation();

  const searchParams = new URLSearchParams(search);
  let selectedMake = (searchParams.get("make") as string) || "";
  let selectedModel = (searchParams.get("model") as string) || "";
  let selectedYear = (searchParams.get("year") as string) || "";
  const refineSearchFromUrl = searchParams.get("refineSearch") ?? null;
  const [productSearched, setProductSearched] = useState<boolean>(false);
  let showedItems: IItemShortResponse[] | undefined = useAppSelector(items)
  const [disableVinInput, setDisableVinInput] = useState(false);
  const [disableKeyPartInput, setDisableKeyPartInput] = useState(false);

  useEffect(() => {
    if (isKeyFinder) {
      onToggleVinInput?.(disableVinInput);
      onToggleKeyPartInput?.(disableKeyPartInput);
    }
  }, [disableVinInput, disableKeyPartInput]);

  useEffect(() => {
    if (vinSearchValue !== "" || keyPartNumberSearchValue !== "") {
      setEnableSearchButton(false);
    }
  }, [disableSearchButton]);
  const getOptions = useCallback(
    (level: number) => {
      let filteredItems = facetItems.filter(
        (levelItem) => levelItem.level === level
      );

      const dropdownOptions = filteredItems.map((levelItem) => {
        return { label: levelItem.name, value: levelItem.name };
      });
      return [
        {
          label: t(facetConfiguration?.levelInfos[level].name ?? "", {
            ns: namespace.coreSrsPrimary,
          }),
          value: "",
        },
        ...dropdownOptions,
      ] as IDropDownOption[];
    },
    [facetItems]
  );

  const getDefaultValue = useCallback(
    (levelName: string) => {
      const level = facetConfiguration?.levelInfos.find(
        (level) => level.name === levelName
      )?.level;

      if (level === 0 && selectedMake) return selectedMake;
      if (level === 1 && selectedModel) return selectedModel;
      if (level === 2 && selectedYear) return selectedYear;

      const value = getValues(levelName as `${number}` | `${number}.${string}`);
      return typeof value === "string" ? value : "";
    },
    [
      facetItems,
      resetInputValues,
      selectedMake,
      selectedModel,
      selectedYear,
      facetConfiguration,
    ]
  );

  const schema = yup.object().shape({
    facetItems: yup.array().of(
      yup.object().shape({
        rootTag: yup.string(),
        level: yup.number(),
        name: yup.string(),
      })
    ),
  });

  const createFacetItems = (...names: (string | number)[]) => {
    return names.map((name, index) => ({
      level: index,
      name: String(name) || "",
      rootTag: "RotundaFacetedTools",
      shouldFetchProducts: true,
    }));
  };
  useEffect(() => {
    if (!productSearched && selectedMake && selectedModel && selectedYear) {
      const facetItemsFromUrl = createFacetItems(
        selectedMake,
        selectedModel,
        selectedYear
      );
      dispatch(updateRequest(facetItemsFromUrl));
      dispatch(
        getFacetedProducts({
          refineSearchCriteria: refineSearchFromUrl
            ? JSON.parse(decodeURIComponent(refineSearchFromUrl)).map(
                (item: string) => item.trim()
              )
            : null,
          isKeyFinderRefineSearch: true,
          facetItems: facetItemsFromUrl,
          pageNumber: 0,
          pageSize: 9,
          sortBy: sortOption,
        })
      ).then(() => {
        handleShowFacetResult(true);
      });
    }
  }, [selectedMake, selectedModel, selectedYear]);

  const methods = useForm<IFormSchema[]>({
    defaultValues: formInputs,

    resolver: yupResolver(schema),
    mode: "all",
  });

  const { control, getValues, setValue, reset } = methods;

  const submitForm = useCallback(
    (e) => {
      setResetInputValues(false);
      const request = createFacetRequest(e);
      setEnableSearchButton(request.every((item) => item.name !== ""));
      dispatch(updateRequest(request));
      if (mainZone) {
        dispatch(updateFromMainZone(true));
        history.push("/facetedSearch");
      }
      if (!mainZone && request && !isKeyFinder) {
        dispatch(clearProducts());
        dispatch(
          getFacetedProducts({
            refineSearchCriteria:
              (refineYourSearchInput ?? []).length > 0
                ? refineYourSearchInput
                : null,
            isKeyFinderRefineSearch: true,
            facetItems: request,
            pageNumber: 0,
            pageSize: 9,
            sortBy: sortOption,
          })
        );
      }
      if (facetConfiguration?.type === FacetedSearchType.Dynamic) {
        dispatch(
          getFacetedOptions({
            facetItems: request,
          } as IFacetedSearchRequest)
        );
      }
    },
    [facetConfiguration, facetItems, isKeyFinder, sortOption]
  );
  const createFacetRequest = (e: any) => {
    let clearSubsequent = false;

    const isMakeReselection =
      e.name ===
        facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name &&
      e.value === selectedMake;

    const isMakeField =
      e.name ===
      facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name;

    if (isMakeField && e.value !== "") {
      setDisableVinInput(true);
      setDisableKeyPartInput(true);
    } else if (isMakeField && e.value === "") {
      setDisableVinInput(false);
      setDisableKeyPartInput(false);
    }

    const request = facetConfiguration?.levelInfos.map((level) => {
      let name = getValues(level.name as `${number}` | `${number}.${string}`);

      if (clearSubsequent) {
        name = "";
        setValue(level.name as `${number}` | `${number}.${string}`, "");
      } else if (level.name === e.name) {
        name = e.value;

        clearSubsequent = true;
      }

      return {
        level: level.level,
        name,
        rootTag: facetConfiguration.rootTag,
      };
    }) as IFacetedItem[];

    if (isMakeReselection && request.length > 1) {
      request[1].name = "";
      if (request.length > 2) {
        request[2].name = "";
      }
    }

    return request;
  };
  const submitFormOnSelectChange = useCallback(
    (e) => {
      setResetInputValues(false);
      const request = createFacetRequest(e);
      setEnableSearchButton(request.every((item) => item.name !== ""));
      dispatch(updateRequest(request));

      if (mainZone) {
        dispatch(updateFromMainZone(true));
        history.push("/facetedSearch");
      }

      if (!mainZone && request && !isKeyFinder) {
        dispatch(clearProducts());
      }

      if (facetConfiguration?.type === FacetedSearchType.Dynamic) {
        const isMakeChange =
          e.name ===
          facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name;

        if (isMakeChange) {
          const refreshRequest = facetConfiguration.levelInfos.map(
            (level, idx) => {
              return {
                level: level.level,
                name: idx === 0 ? e.value ?? null : null,
                rootTag: facetConfiguration.rootTag,
              } as IFacetedItem;
            }
          );

          dispatch(
            getFacetedOptions({
              facetItems: refreshRequest,
            } as IFacetedSearchRequest)
          );
        } else {
          dispatch(
            getFacetedOptions({
              facetItems: request,
            } as IFacetedSearchRequest)
          );
        }
      }
    },
    [facetConfiguration, facetItems, isKeyFinder]
  );
  const handleSelectChange = (e: { name?: string; value: string }) => {
    const makeFieldName = facetConfiguration?.levelInfos.find(
      (l) => l.level === 0
    )?.name;
    if (e.name === makeFieldName) {
      const isEmpty = !e.value || e.value === "Select Make";
      setDisableVinInput(!isEmpty);
      setDisableKeyPartInput(!isEmpty);

      onToggleVinInput?.(!isEmpty);
      onToggleKeyPartInput?.(!isEmpty);
    }

    if (
      e.name === facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name
    ) {
      const isEmpty = e.value === "" || e.value === "Select Make";
      setDisableVinInput(!isEmpty);
      setDisableKeyPartInput(!isEmpty);
    }

    onSearchButtonClick(false);
    setProductSearched(false);

    const isDefaultOption =
      e.value === "" ||
      e.value === "Select Year" ||
      e.value === "Select Make" ||
      e.value === "Select Model" ||
      e.value === t(e.name ?? "", { ns: namespace.coreSrsPrimary });

    const isMakeReselection =
      !isDefaultOption &&
      e.name ===
        facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name &&
      e.value === selectedMake;

    if (isMakeReselection) {
      const modelField = facetConfiguration?.levelInfos.find(
        (l) => l.level === 1
      )?.name;
      const yearField = facetConfiguration?.levelInfos.find(
        (l) => l.level === 2
      )?.name;

      if (modelField) {
        setValue(modelField as `${number}` | `${number}.${string}`, "");
      }

      if (yearField) {
        setValue(yearField as `${number}` | `${number}.${string}`, "");
      }

      setTimeout(() => {
        const modelElement = document.getElementById(modelField ?? "");
        if (modelElement) {
          const displayElement =
            modelElement.querySelector(".MuiSelect-select");
          if (displayElement) {
            const defaultText = t(modelField ?? "", {
              ns: namespace.coreSrsPrimary,
            });
            displayElement.textContent = defaultText;
          }
        }

        const yearElement = document.getElementById(yearField ?? "");
        if (yearElement) {
          const displayElement = yearElement.querySelector(".MuiSelect-select");
          if (displayElement) {
            const defaultText = t(yearField ?? "", {
              ns: namespace.coreSrsPrimary,
            });
            displayElement.textContent = defaultText;
          }
        }
      }, 50);
    }

    const modifiedField = isDefaultOption ? { value: "", name: e.name } : e;

    if (isDefaultOption && e.name) {
      const isMakeField =
        e.name ===
        facetConfiguration?.levelInfos.find((l) => l.level === 0)?.name;
      const isModelField =
        e.name ===
        facetConfiguration?.levelInfos.find((l) => l.level === 1)?.name;
      const isYearField =
        e.name ===
        facetConfiguration?.levelInfos.find((l) => l.level === 2)?.name;

      if (isMakeField) {
        selectedMake = "";
        selectedModel = "";
        selectedYear = "";

        const modelField = facetConfiguration?.levelInfos.find(
          (l) => l.level === 1
        )?.name;
        const yearField = facetConfiguration?.levelInfos.find(
          (l) => l.level === 2
        )?.name;

        if (modelField) {
          setValue(modelField as `${number}` | `${number}.${string}`, "");
        }

        if (yearField) {
          setValue(yearField as `${number}` | `${number}.${string}`, "");
        }

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("make");
        searchParams.delete("model");
        searchParams.delete("year");
        history.replace(
          searchParams.toString()
            ? `?${searchParams.toString()}`
            : location.pathname
        );
      } else if (isModelField) {
        selectedModel = "";
        selectedYear = "";

        const yearField = facetConfiguration?.levelInfos.find(
          (l) => l.level === 2
        )?.name;

        if (yearField) {
          setValue(yearField as `${number}` | `${number}.${string}`, "");
        }

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("model");
        searchParams.delete("year");
        history.replace(
          searchParams.toString()
            ? `?${searchParams.toString()}`
            : location.pathname
        );
      } else if (isYearField) {
        selectedYear = "";

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("year");
        history.replace(
          searchParams.toString()
            ? `?${searchParams.toString()}`
            : location.pathname
        );
      }

      setValue(e.name as `${number}` | `${number}.${string}`, "");

      setTimeout(() => {
        const selectElement = document.getElementById(e.name ?? "");
        if (selectElement) {
          const displayElement =
            selectElement.querySelector(".MuiSelect-select");
          if (displayElement) {
            const defaultText = t(e.name ?? "", {
              ns: namespace.coreSrsPrimary,
            });
            displayElement.textContent = defaultText;
            (displayElement as HTMLElement).setAttribute("data-value", "");
            const event = new Event("change", { bubbles: true });
            displayElement.dispatchEvent(event);
          }
        }
      }, 50);

      if (isMakeField || isModelField) {
        setTimeout(() => {
          if (isMakeField) {
            const modelField = facetConfiguration?.levelInfos.find(
              (l) => l.level === 1
            )?.name;
            const modelElement = document.getElementById(modelField ?? "");
            if (modelElement) {
              const displayElement =
                modelElement.querySelector(".MuiSelect-select");
              if (displayElement) {
                const defaultText = t(modelField ?? "", {
                  ns: namespace.coreSrsPrimary,
                });
                displayElement.textContent = defaultText;
              }
            }
          }

          const yearField = facetConfiguration?.levelInfos.find(
            (l) => l.level === 2
          )?.name;
          const yearElement = document.getElementById(yearField ?? "");
          if (yearElement) {
            const displayElement =
              yearElement.querySelector(".MuiSelect-select");
            if (displayElement) {
              const defaultText = t(yearField ?? "", {
                ns: namespace.coreSrsPrimary,
              });
              displayElement.textContent = defaultText;
            }
          }
        }, 75);
      }
    }

    submitFormOnSelectChange(modifiedField);
  };
  useEffect(() => {
    if (!fromMainZone) dispatch(clearProducts());
  }, []);

  useEffect(() => {
    if (resetInput) {
      setResetInputValues(true);
      setResetInputFields(false);
    }
  }, [resetInput]);

  useEffect(() => {
    if (!facetConfiguration) {
      dispatch(getFacetedConfigurations());
    }
  }, [facetConfiguration]);

  useEffect(() => {
    if (facetConfiguration && facetItems.length > 0) {
      let request;
      if (fromMainZone) {
        request = requestFromMainZone;
        if (requestFromMainZone) {
          facetConfiguration?.levelInfos.forEach((config, index) => {
            setValue(
              config.name as `${number}` | `${number}.${string}`,
              Object.values(requestFromMainZone)[index].name as string
            );
          });
        }
        dispatch(updateFromMainZone(false));
      } else {
        if (selectedMake && selectedModel && selectedYear) {
            request = createFacetItems(selectedMake, selectedModel, selectedYear);
        } else {
          request = facetConfiguration?.levelInfos.map((level) => {
            return {
              level: level.level,
              name: null,
              rootTag: facetConfiguration.rootTag,
            } as IFacetedItem;
          });
        }
        dispatch(updateRequest(request));
      }
      if (!mainZone && request) {
        dispatch(clearProducts());
      }
    }
  }, [facetConfiguration, sortOption]);

  const createFieldsAndGetOptions = async () => {
    if (facetConfiguration) {
      setFormInputs(
        facetConfiguration?.levelInfos.reduce<IFormSchema[]>((acc, cur) => {
          return [...acc, { [cur.name]: cur.name }];
        }, [])
      );

      const facetedItemsRequest = facetConfiguration.levelInfos.map((level) => {
        return {
          rootTag: facetConfiguration.rootTag,
          name: null,
          level: level.level,
        } as IFacetedItem;
      });
      dispatch(
        getFacetedOptions({
          facetItems: facetedItemsRequest,
        } as IFacetedSearchRequest)
      );
    }
  };
  useEffect(() => {
    if (!fromMainZone && !selectedMake && !selectedModel && !selectedYear)
      createFieldsAndGetOptions();
  }, [facetConfiguration]);

  const createRequest = (facetConfiguration: FacetConfiguration) => {
    return facetConfiguration?.levelInfos.map((level) => {
      return {
        level: level.level,
        name: getValues(level.name as `${number}` | `${number}.${string}`),
        rootTag: facetConfiguration.rootTag,
      } as IFacetedItem;
    });
  };

  useEffect(() => {
    const compareArrays = (currentInput: any, prevInput: any) => {
      if (currentInput.length !== prevInput.length) {
        return false;
      }

      const sortedCurrentInput = [...currentInput].sort((a, b) => a - b);
      const sortedPrevInput = [...prevInput].sort((a, b) => a - b);

      return sortedCurrentInput.every(
        (item, index) => item === sortedPrevInput[index]
      );
    };

    if (prevRefineSearchInput.current === undefined) {
      prevRefineSearchInput.current = refineYourSearchInput;
      return;
    }
    if (!compareArrays(refineYourSearchInput, prevRefineSearchInput.current)) {
      if (
        showFacetResult &&
        facetConfiguration &&
        (refineYourSearchInput?.length ?? 0) > 0
      ) {
        dispatch(clearState());
        dispatch(clearAll());
        dispatch(clearProducts());
        const request = createRequest(facetConfiguration);
        dispatch(
          getFacetedProducts({
            refineSearchCriteria:
              (refineYourSearchInput ?? []).length > 0
                ? refineYourSearchInput
                : null,
            isKeyFinderRefineSearch: true,
            facetItems: request,
            pageNumber: 0,
            pageSize: 9,
            sortBy: sortOption,
          })
        ).then(() => {
          handleShowFacetResult(true);
        });
        prevRefineSearchInput.current = refineYourSearchInput;
      }
    }
  }, [refineYourSearchInput, sortOption]);

  useEffect(() => {
    customSearch();
  }, [sortOption]);
 useEffect(() => {
    // Only reset state if there are no search parameters in the URL
    if(searchParams.get("make") === null && 
       searchParams.get("model") === null && 
       searchParams.get("year") === null &&
       isKeyFinder) {  
      const referrer = document.referrer;
      const isReturningFromItemDetails = referrer && 
                                       referrer.includes(window.location.host) && 
                                       referrer.includes('/ItemDetail');
      const isDirectNavigation = history.action === 'PUSH' && !isReturningFromItemDetails;
      if (isDirectNavigation) {
        handleReset?.();
        dispatch(clearAll());
        reset();
        setResetInputValues(true);
        if (facetConfiguration) {
          facetConfiguration.levelInfos.forEach((level) => {
            setValue(level.name as `${number}` | `${number}.${string}`, "");
          });
        }
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("make");
        searchParams.delete("model");
        searchParams.delete("year");
        history.replace(
          searchParams.toString()
            ? `?${searchParams.toString()}`
            : location.pathname
        );
        createFieldsAndGetOptions();
      }
    }
  }, [search, history.location.pathname, history.action]);
  const customSearch = () => {
    dispatch(clearProducts());
    onSearchButtonClick(true);
    setProductSearched(true);
    setShowRefineSearch(false);
    setRefineYourSearchInput([]);
    dispatch(clearRefineCatalogs());
    dispatch(clearProductRefineCatalogs());
    dispatch(clearState());
    dispatch(clearAll());
    if (facetConfiguration) {
      const request = createRequest(facetConfiguration);

      let searchText = "";
      request.forEach((item) => {
        searchText += item.name + " ";
      });
      setSearchText(searchText.trim());
      if (request?.[2]?.name) {
        let url = `make=${encodeURIComponent(
          request[0].name ?? ""
        )}&model=${encodeURIComponent(
          request[1].name ?? ""
        )}&year=${encodeURIComponent(request[2].name ?? "")}`;
        history.replace(`?${url}`);
        dispatch(updateRequest(request));
        dispatch(
          getFacetedProducts({
            refineSearchCriteria: null,
            isKeyFinderRefineSearch: true,
            facetItems: request,
            pageNumber: 0,
            pageSize: 9,
            sortBy: sortOption,
          })
        ).then(() => {
          handleShowFacetResult(true);
        });
      }
    } else {
      console.warn("facetConfiguration is undefined");
    }
  };

  function handleResetInputs(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    dispatch(clearProducts());
    reset();
    setResetInputValues(true);
    handleReset?.();
    setEnableSearchButton(false);
    history.replace(history.location.pathname);
    const request = facetConfiguration?.levelInfos.map((level) => {
      return {
        level: level.level,
        name: undefined,
        rootTag: facetConfiguration.rootTag,
      } as IFacetedItem;
    });

    dispatch(updateRequest(request));
    if (!mainZone && request) {
      dispatch(clearProducts());
    }

    if (facetConfiguration?.type === FacetedSearchType.Dynamic) {
      dispatch(
        getFacetedOptions({
          facetItems: request,
        } as IFacetedSearchRequest)
      );
    }

    createFieldsAndGetOptions();
  }
  useEffect(() => {
    if (facetConfiguration && (selectedMake || selectedModel || selectedYear)) {
      if (selectedMake) {
        const makeField = facetConfiguration.levelInfos.find(
          (level) => level.level === 0
        )?.name;
        if (makeField) {
          setValue(
            makeField as `${number}` | `${number}.${string}`,
            selectedMake
          );
        }
      }

      if (selectedModel) {
        const modelField = facetConfiguration.levelInfos.find(
          (level) => level.level === 1
        )?.name;
        if (modelField) {
          setValue(
            modelField as `${number}` | `${number}.${string}`,
            selectedModel
          );
        }
      }

      if (selectedYear) {
        const yearField = facetConfiguration.levelInfos.find(
          (level) => level.level === 2
        )?.name;
        if (yearField) {
          setValue(
            yearField as `${number}` | `${number}.${string}`,
            selectedYear
          );
        }
      }

      const request = facetConfiguration.levelInfos.map((level, index) => {
        let name = null;
        if (index === 0) {
          name = selectedMake || null;
        } else if (index === 1) {
          name = selectedModel || null;
        } else if (index === 2) {
          name = selectedYear || null;
        }
        return {
          level: level.level,
          name,
          rootTag: facetConfiguration.rootTag,
        } as IFacetedItem;
      });

      dispatch(
        getFacetedOptions({
          facetItems: request,
        } as IFacetedSearchRequest)
      );
    }
  }, [facetConfiguration, selectedMake, selectedModel, selectedYear]);

  return (
    <>
    {(showedItems === undefined || showedItems.length <= 0) && <LoadingIndicator />}
     <div>
        <S.SelectsForm
          onSubmit={submitForm}
          mainImage={mainZone}
          isKeyFinder={isKeyFinder}
        >
          {!isKeyFinder && (
            <S.Text mainImage={mainZone}>
              {" "}
              {translate("FacetedSearchBrowseText")}{" "}
            </S.Text>
          )}
          {facetConfiguration?.levelInfos?.map((level) => {
            let urlValue = null;
            if (level.level === 0) {
              urlValue = selectedMake;
            } else if (level.level === 1) {
              urlValue = selectedModel;
            } else if (level.level === 2) {
              urlValue = selectedYear;
            }

            return (
              <FacetedSearchSelectInput
                key={`${level.name}-${urlValue ?? ""}`}
                control={control}
                options={getOptions(level.level)}
                name={level.name}
                onChange={handleSelectChange}
                id={level.name}
                //eslint-disable-next-line
                selectedValue={urlValue || getDefaultValue(level.name)}
                resetValue={resetInputValues}
                isKeyFinder={isKeyFinder}
                disabled={disableSelects}
              />
            );
          })}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {!mainZone && (
              <button
                onClick={handleResetInputs}
                id="keyFinderResetBtn"
                type="button"
              >
                {translate(`ltl_ClearAllText`)}
              </button>
            )}
            {isKeyFinder && (
              <div className="hideFocus ">
                <S.Button
                  id="makeModelYearSubmitBtn"
                  type="button"
                  onClick={customSearch}
                  disabled={!enableSearchButton}
                  style={{
                    opacity: !enableSearchButton ? 0.3 : 1,
                  }}
                >
                  {translate(`lblSearch`)}
                </S.Button>
              </div>
            )}
          </div>
        </S.SelectsForm>
      </div>
    </>
  );
};

export default FacetedSearch;
